import Button from 'components/atoms/Button';
import Loader from 'components/molecules/Loader';
import { CustomModalForSave } from 'components/pages/PromoRecommendation';
import React, { useContext, useState } from 'react';
import { calculateFontSize } from 'utils/helperMethods';
import { trackEventMixpanel } from 'utils/mixpanel';
import { PROMO_RECOMMENDATION_NEW_SCENARIO_INPUT_ADDED } from 'utils/mixpanelEventNames';

interface props {
    setSaveScenario: Function;
    onSave: Function;
    saveScenario: any;
    loading?: boolean;
    error?: string;
    title?: string;
    setError?: Function;
}
const ScaleInput = calculateFontSize(window.innerWidth, 200);
function SaveScenarioModal({ setError, setSaveScenario, saveScenario, onSave, loading, error, title }: props) {
    const [text, setText] = useState('');
    const handleOk = () => {
        setSaveScenario(false);
    };

    const handleCancel = () => {
        setSaveScenario(false);
    };

    let Footer = () => {
        return (
            <div className="w-full flex justify-end gap-2">
                <Button title={'Cancel'} onClick={() => setSaveScenario(false)} style={{ padding: '0px 20px' }} />
                <Button
                    title={'Save'}
                    onClick={() => {
                        if (!text.trim()) return;
                        onSave({ text: text });
                    }}
                    theme={'Solid'}
                    style={{ padding: '0px 20px' }}
                />
            </div>
        );
    };

    return (
        <>
            {loading && (
                <div className="fixed inset-0 bg-[#edf0f3] z-[1001] opacity-60">
                    <Loader />
                </div>
            )}
            <CustomModalForSave
                afterClose={() => {
                    setText('');
                    if (setError) setError(null);
                }}
                destroyOnClose
                title={title}
                open={saveScenario}
                onOk={handleOk}
                onCancel={handleCancel}
                centered
                width={400}
                footer={Footer()}
            >
                <div className="flex w-full flex-col gap-2 -mt-4">
                    <div className="flex w-full flex-col gap-1">
                        <span className="font-xs font-medium">Name</span>
                        <span className="border border-purpleFont rounded flex">
                            <input
                                className="m-0.5 focus:outline-none w-full"
                                onChange={(e) => {
                                    setText(e.target.value);
                                    trackEventMixpanel(PROMO_RECOMMENDATION_NEW_SCENARIO_INPUT_ADDED, {
                                        name: e.target.value,
                                    });
                                }}
                                value={text}
                                placeholder="Enter Name"
                            />
                        </span>
                        {error && <p className="text-redTriangle font-xxs font-medium">{error}</p>}
                    </div>
                    {/* <div className="flex w-full flex-col gap-1">
                    <span className="font-xs font-medium">Comment</span>
                    <span className="border border-purpleFont rounded flex">
                        <textarea
                            placeholder="Enter Comment"
                            className="m-1 focus:outline-none"
                            rows={4}
                            cols={50}
                        ></textarea>
                    </span>
                </div> */}
                </div>
            </CustomModalForSave>
        </>
    );
}

export default SaveScenarioModal;
